export class utilities {
    static generaLigaImagen(url: string, esVacio: boolean = false): string {
        const ligaCDN = 'https://cdn.gdar.com.mx/archivos/';
        if (esVacio) {
            return url;
        } else {
            return `${ligaCDN}${url}`;

        }
    }
}
